var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-343dc3f7"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex items-center px-6 pt-6 min-w-0" };
var _hoisted_2 = { class: "ml-4 font-medium truncate text-right" };
var _hoisted_3 = { class: "flex items-center py-0 px-5 -mx-1 mt-7 space-x-2 w-full" };
var _hoisted_4 = { class: "chats" };
var _hoisted_5 = {
    key: 0,
    class: "px-7 pt-10 text-gray-400"
};
var _hoisted_6 = { key: 0 };
var _hoisted_7 = { key: 1 };
var _hoisted_8 = { key: 2 };
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
import { clone, dynamicSort } from '@common/utils/Helpers/Helpers';
import { computed, getCurrentInstance, ref, watch } from 'vue';
import { ChatStore, CoreStore } from '@common/stores';
import EInput from '@common/ui/EInput.vue';
import ESelect from '@common/ui/ESelect/ESelect.vue';
import ChatLink from '@common/components/Messages/components/School/components/components/ChatLink.vue';
import EScrollbar from '@common/ui/EScrollbar.vue';
import { useI18n } from "vue-i18n";
import { getAndroidApplicationVersion, isAndroidApp } from "@common/utils/MobileApp";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CommonChats',
    setup: function (__props) {
        var coreStore = CoreStore;
        var t = useI18n().t;
        var search = ref('');
        var sort = ref('lastmessage');
        var filter = ref([]);
        var filterValues = [
            {
                value: 'courses',
                label: t('commonChats.filter.courses'),
            },
            {
                value: 'dialogues',
                label: t('commonChats.filter.dialogues'),
            },
            {
                value: 'school',
                label: t('commonChats.filter.school'),
            },
        ];
        var sortValues = [
            {
                value: 'lastmessage',
                label: t('commonChats.sort.lastMessage'),
            },
            {
                value: 'name',
                label: t('commonChats.sort.name'),
            },
        ];
        var school = computed(function () { return coreStore.school; });
        var chats = computed(function () { return ChatStore.chats; });
        var teachers = computed(function () { var _a; return (_a = ChatStore.teachers) !== null && _a !== void 0 ? _a : []; });
        var schoolSection = computed(function () { return ChatStore.schoolSection; });
        var isAndroid = isAndroidApp();
        var isNewAndroidApp = getAndroidApplicationVersion();
        var isNeedPadding = computed(function () { return isAndroid && !isNewAndroidApp; });
        var courses = computed(function () {
            var e_1, _a;
            var chatsLocal = clone(chats.value.filter(function (c) { return c.course; }));
            var courses = [];
            var _loop_1 = function (chat) {
                var course = chat.course;
                course.unreadMessages = chat.unreadMessages;
                var courseExistIndex = courses.findIndex(function (c) { return c.id === course.id; });
                if (courseExistIndex === -1) {
                    courses.push(course);
                }
                else {
                    courses[courseExistIndex].unreadMessages += chat.unreadMessages;
                }
            };
            try {
                for (var chatsLocal_1 = __values(chatsLocal), chatsLocal_1_1 = chatsLocal_1.next(); !chatsLocal_1_1.done; chatsLocal_1_1 = chatsLocal_1.next()) {
                    var chat = chatsLocal_1_1.value;
                    _loop_1(chat);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (chatsLocal_1_1 && !chatsLocal_1_1.done && (_a = chatsLocal_1.return)) _a.call(chatsLocal_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return courses;
        });
        var currentChat = computed(function () { return ChatStore.contentChat; });
        var schoolCommonChats = computed(function () {
            if ((!chats.value || chats.value.length <= 0)
                && (!teachers.value || teachers.value.length <= 0)) {
                return [];
            }
            var chatsLocal = [];
            if (filter.value.length === 0 || filter.value.includes('school')) {
                var schoolChats = chats.value
                    .filter(function (c) { return c.school; })
                    .map(function (c) {
                    return __assign(__assign({}, c), { objectType: 'chat' });
                });
                chatsLocal.push.apply(chatsLocal, __spreadArray([], __read(schoolChats), false));
            }
            if (filter.value.length === 0 || filter.value.includes('courses')) {
                var coursesList = clone(courses.value)
                    .map(function (course) {
                    var e_2, _a;
                    var courseChats = chats.value.filter(function (chat) {
                        return chat.course && chat.course.id === course.id;
                    });
                    var lastMessage;
                    try {
                        for (var courseChats_1 = __values(courseChats), courseChats_1_1 = courseChats_1.next(); !courseChats_1_1.done; courseChats_1_1 = courseChats_1.next()) {
                            var chat = courseChats_1_1.value;
                            if (chat.lastMessage
                                && (!lastMessage || chat.lastMessage.createdAt > lastMessage.createdAt)) {
                                lastMessage = chat.lastMessage;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (courseChats_1_1 && !courseChats_1_1.done && (_a = courseChats_1.return)) _a.call(courseChats_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return __assign(__assign({}, course), { lastMessage: lastMessage, objectType: 'course' });
                });
                chatsLocal.push.apply(chatsLocal, __spreadArray([], __read(coursesList), false));
            }
            if (filter.value.length === 0 || filter.value.includes('dialogues')) {
                var dialogues = chats.value
                    .filter(function (c) { return c.type === 'dialogue'; })
                    .map(function (c) {
                    return __assign(__assign({}, c), { objectType: 'dialogue' });
                });
                chatsLocal.push.apply(chatsLocal, __spreadArray([], __read(dialogues), false));
            }
            if (filter.value.length === 0 || filter.value.includes('dialogues')) {
                var teachersLocal = teachers.value
                    .filter(function (t) {
                    return !chats.value.some(function (chat) {
                        return chat.type === 'dialogue' && chat.recipient.id === t.id;
                    });
                })
                    .map(function (t) {
                    return __assign(__assign({}, t), { objectType: 'teacher' });
                });
                chatsLocal.push.apply(chatsLocal, __spreadArray([], __read(teachersLocal), false));
            }
            if (search.value.length > 0) {
                var searchString_1 = search.value.toLowerCase();
                chatsLocal = chatsLocal.filter(function (chat) {
                    var _a;
                    // eslint-disable-next-line unicorn/prefer-ternary
                    if (chat.type === 'dialogue') {
                        return (chat.recipient.email || '').toLowerCase().includes(searchString_1)
                            || (chat.name || '').toLowerCase().includes(searchString_1);
                    }
                    else {
                        return chat.name.toLowerCase().includes(searchString_1) || ((_a = chat.email) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchString_1));
                    }
                });
            }
            chatsLocal = sort.value === 'name' ? chatsLocal.sort(dynamicSort('name')) : chatsLocal.toSorted(function (a, b) {
                if (!a.lastMessage) {
                    return 1;
                }
                else if (!b.lastMessage) {
                    return -1;
                }
                if (a.lastMessage.createdAt === b.lastMessage.createdAt) {
                    return 0;
                }
                return a.lastMessage.createdAt < b.lastMessage.createdAt ? 1 : -1;
            });
            return chatsLocal;
        });
        var getRoleName = function (role) {
            var roleTranslations = {
                'Редактор школы': t('roles.schoolEditor'),
                'Преподаватель': t('roles.teacher'),
                'Редактор курсов': t('roles.courseEditor'),
                'Администратор': t('roles.admin'),
                'Владелец': t('roles.owner'),
                'Поддержка Skillspace': t('roles.skillspaceSupport')
            };
            return roleTranslations[role] || role;
        };
        watch(chats, function () {
            var _a, _b;
            (_b = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy) === null || _b === void 0 ? void 0 : _b.$forceUpdate();
        });
        var openCourse = function (course) {
            ChatStore.schoolSection = 'course';
            ChatStore.openCourse(course);
        };
        var openChat = function (chat) {
            ChatStore.openChatPage(chat);
        };
        var goSettings = function () {
            ChatStore.openSettingsPage();
        };
        var openTeacherChat = function (chat) {
            ChatStore.openDialogue(chat.id);
        };
        return function (_ctx, _cache) {
            var _a;
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{
                        'common-chats--hidden': schoolSection.value !== 'common'
                    }, "flex overflow-x-hidden absolute top-0 left-0 z-10 flex-col flex-grow w-full h-full max-h-full transition-all duration-200 common-chats"])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass([isNeedPadding.value ? 'pt-6' : 'pt-4', "flex justify-between pt-4"])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_e_icon, {
                            class: "shrink-0 w-5 h-5 text-gray-300",
                            icon: "bicolor/chat"
                        }),
                        _createElementVNode("p", _hoisted_2, _toDisplayString((_a = school.value) === null || _a === void 0 ? void 0 : _a.name), 1)
                    ])
                ], 2),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(EInput, {
                        modelValue: search.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((search).value = $event); }),
                        class: "flex-1",
                        placeholder: _unref(t)('commonChats.searchPlaceholder'),
                        theme: "gray"
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "w-4 h-4 text-gray-400",
                                icon: "search"
                            })
                        ]; }),
                        _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(ESelect, {
                        modelValue: filter.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((filter).value = $event); }),
                        class: _normalizeClass([
                            filter.value.length > 0 && '!bg-primary-100'
                        ]),
                        options: filterValues,
                        theme: "gray",
                        "dynamic-overlay-width": "",
                        "empty-content": "",
                        multiple: ""
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: _normalizeClass([[
                                        filter.value.length > 0 && 'text-primary'
                                    ], "w-3 h-3 text-gray-300"]),
                                icon: "filter"
                            }, null, 8, ["class"])
                        ]; }),
                        _: 1
                    }, 8, ["modelValue", "class"]),
                    _createVNode(ESelect, {
                        modelValue: sort.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((sort).value = $event); }),
                        class: _normalizeClass([
                            sort.value === 'name' && '!bg-primary-100'
                        ]),
                        options: sortValues,
                        theme: "gray",
                        "dynamic-overlay-width": "",
                        "empty-content": ""
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: _normalizeClass([[
                                        sort.value === 'name' && 'text-primary'
                                    ], "w-3 h-3 text-gray-300"]),
                                icon: "direction"
                            }, null, 8, ["class"])
                        ]; }),
                        _: 1
                    }, 8, ["modelValue", "class"])
                ]),
                _createVNode(EScrollbar, {
                    options: { suppressScrollX: true },
                    class: "mt-4"
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_4, [
                            (schoolCommonChats.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (filter.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('commonChats.noChatsWithFilters')), 1))
                                        : (search.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('commonChats.noChatsWithSearch', { search: search.value })), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                                _createTextVNode(_toDisplayString(_unref(t)('commonChats.noChatsDefault')) + " ", 1),
                                                _hoisted_9,
                                                _createTextVNode(" " + _toDisplayString(_unref(t)('commonChats.noChatsDefaultText')), 1)
                                            ]))
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolCommonChats.value, function (chat) {
                                var _a, _b, _c, _d;
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (chat.objectType === 'chat')
                                        ? (_openBlock(), _createBlock(ChatLink, {
                                            key: chat.id + chat.objectType,
                                            active: currentChat.value.id === chat.id,
                                            avatar: chat.avatar,
                                            "is-audio": !!((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.audio),
                                            "last-message-file-type": chat.lastMessage ? chat.lastMessage.fileType : '',
                                            "last-message-text": chat.lastMessage ? chat.lastMessage.text : '',
                                            "last-message-time": chat.lastMessage ? chat.lastMessage.createdAt : 0,
                                            name: chat.name,
                                            type: chat.type,
                                            "unread-messages-count": chat.unreadMessages,
                                            onClick: function ($event) { return (openChat(chat)); }
                                        }, null, 8, ["active", "avatar", "is-audio", "last-message-file-type", "last-message-text", "last-message-time", "name", "type", "unread-messages-count", "onClick"]))
                                        : (chat.objectType === 'course')
                                            ? (_openBlock(), _createBlock(ChatLink, {
                                                key: chat.id + chat.objectType,
                                                active: currentChat.value
                                                    && currentChat.value.course
                                                    && currentChat.value.course.id === chat.id,
                                                avatar: chat.cover,
                                                "is-audio": !!((_b = chat.lastMessage) === null || _b === void 0 ? void 0 : _b.audio),
                                                "last-message-file-type": chat.lastMessage ? chat.lastMessage.fileType : '',
                                                "last-message-text": chat.lastMessage ? chat.lastMessage.text : _unref(t)('commonChats.allCourseChats'),
                                                "last-message-time": chat.lastMessage ? chat.lastMessage.createdAt : 0,
                                                name: chat.name,
                                                "unread-messages-count": chat.unreadMessages,
                                                type: "course",
                                                onClick: function ($event) { return (openCourse(chat)); }
                                            }, null, 8, ["active", "avatar", "is-audio", "last-message-file-type", "last-message-text", "last-message-time", "name", "unread-messages-count", "onClick"]))
                                            : (chat.objectType === 'dialogue')
                                                ? (_openBlock(), _createBlock(ChatLink, {
                                                    key: chat.id + chat.objectType,
                                                    active: currentChat.value.id === chat.id,
                                                    avatar: chat.avatar,
                                                    "is-audio": !!((_c = chat.lastMessage) === null || _c === void 0 ? void 0 : _c.audio),
                                                    "last-message-file-type": chat.lastMessage ? chat.lastMessage.fileType : '',
                                                    "last-message-text": chat.lastMessage ? chat.lastMessage.text : '',
                                                    "last-message-time": chat.lastMessage ? chat.lastMessage.createdAt : 0,
                                                    name: chat.name ? chat.name : chat.recipient.email,
                                                    "unread-messages-count": chat.unreadMessages,
                                                    user: chat.recipient,
                                                    type: "dialogue",
                                                    onClick: function ($event) { return (openChat(chat)); }
                                                }, null, 8, ["active", "avatar", "is-audio", "last-message-file-type", "last-message-text", "last-message-time", "name", "unread-messages-count", "user", "onClick"]))
                                                : (chat.objectType === 'teacher')
                                                    ? (_openBlock(), _createBlock(ChatLink, {
                                                        key: chat.id + chat.objectType,
                                                        active: currentChat.value.recipient && currentChat.value.recipient.id === chat.id,
                                                        avatar: chat.avatar,
                                                        "is-audio": !!((_d = chat.lastMessage) === null || _d === void 0 ? void 0 : _d.audio),
                                                        "last-message-text": getRoleName(chat.employeeRoleName),
                                                        name: chat.name ? chat.name : chat.email,
                                                        user: chat,
                                                        type: "dialogue",
                                                        onClick: function ($event) { return (openTeacherChat(chat)); }
                                                    }, null, 8, ["active", "avatar", "is-audio", "last-message-text", "name", "user", "onClick"]))
                                                    : _createCommentVNode("", true)
                                ], 64));
                            }), 256))
                        ])
                    ]; }),
                    _: 1
                })
            ], 2));
        };
    }
});
